
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.995","height":"17.995"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon feather-edit","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 682","d":"M8.154 2.686H2.59A1.59 1.59 0 001 4.276v11.129a1.59 1.59 0 001.59 1.59h11.129a1.59 1.59 0 001.59-1.59V9.84"}}),_c('path',{attrs:{"data-name":"패스 683","d":"M14.117 1.494a1.688 1.688 0 012.385 2.388L8.95 11.431l-3.18.795.795-3.18z"}})])])
          )
        }
      }
    